import { Pipe, PipeTransform } from '@angular/core';

import { IBomModel } from '../../prisma-xs/models/bom.model';

@Pipe({
    name: 'isTherePreWiringDevices',
    standalone: false
})
export class IsTherePreWiringDevicesPipe implements PipeTransform {
  transform(bomModels: IBomModel[]): boolean {
    return bomModels?.filter(m => m.article.deliverToCustomer === false)?.length > 0;
  }
}
